import { nanoid } from 'nanoid';
import { getCSP, nonce, SELF, UNSAFE_INLINE, NONE } from 'csp-header';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const nonceValue = nanoid(8);
export const csp = getCSP({
  directives: {
    'default-src': [NONE],
    'base-uri': [NONE],
    'prefetch-src': [SELF],
    'script-src': [
      SELF,
      "'self'",
      '*.flippback.com',
      '*.flipp.com',
      '*.wishabi.ca',
      '*.facebook.net',
      '*.onelink.me',
      'securepubads.g.doubleclick.net',
      'stats.g.doubleclick.net',
      'pagead2.googlesyndication.com',
      'googletagmanager.com',
      'www.googleapis.com',
      'www.google-analytics.com',
      'accounts.google.com',
      'graph.facebook.com',
      'www.facebook.com',
      'analytics.google.com',
      'cdn-cookieyes.com',
      '*.cookieyes.com',
      nonce(nonceValue),
    ],
    'img-src': [
      SELF,
      'data:',
      'https://f.wishabi.net',
      'http://f.wishabi.net',
      'https://images.wishabi.net',
      'http://images.wishabi.net',
      'https://www.google-analytics.com/',
      'www.google.com',
      '*.googlesyndication.com',
    ],
    'style-src': [SELF, UNSAFE_INLINE],
    'font-src': [SELF],
    'frame-src': [SELF, 'figma.com', 'www.google.com', '*.googlesyndication.com'],
    'connect-src': [
      SELF,
      'gateflipp.flippback.com',
      'flipp-com-apis.flippback.com',
      'flipp-com-apis-stg.flippback.com',
      'www.google-analytics.com',
      'cdn-gateflipp-stg.flippback.com',
      'stats.g.doubleclick.net',
      'securepubads.g.doubleclick.net',
      'pagead2.googlesyndication.com',
    ],
  },
});
